export const CourseOutlineNote_DataTemplate = (data) => {
  const {
    subjectCode, subject, teacher
  } = data;
  const subjectNameLocal = subject ? subject.nameLocal : "";
  const subjectDescription = subject ? subject.description : "";
  const subjectCreditCalGrade = subject ? subject.creditCalGrade : 0;
  const teacherFirstNameLocal = teacher ? teacher.firstNameLocal : "";
  const teacherLastNameLocal = teacher ? teacher.lastNameLocal : "";

  return {
    subjectCode,
    subjectNameLocal,
    subjectDescription,
    subjectCreditCalGrade,
    teacherFirstNameLocal,
    teacherLastNameLocal,
  }
};

export const CourseOutlineAssessments_DataTemplate = (data) => {
  const {
    courseOutlineAssessments
  } = data;

  return {assessments: courseOutlineAssessments, courseOutlineId: data.id};
};

export const CourseOutlineInstruction_DataTemplate = (data) => {
  const {
    instruction = "",
    streamIntroPath = ""
  } = data;

  return {
    instruction,
    streamIntroPath
  }
};

export const CourseOutlineUnits_DataTemplate = (data) => {
  const {
    courseOutlineUnits
  } = data;
  const list = courseOutlineUnits ? [...courseOutlineUnits] : [];
  let units = list;
  if (units.length < 15) {
    for (let i = units.length; i < 15; i += 2) {
      units.push(null);
    }
  }

  return {units, courseOutlineId: data.id};
};

export const CourseOutlineTextBooks_DataTemplate = (data) => {
  const books = {
    bookName1: data.bookName1 || "",
    bookPic1: data.bookPic1 || "",
    bookDescription1: data.bookDescription1 || "",
    bookName2: data.bookName2 || "",
    bookPic2: data.bookPic2 || "",
    bookDescription2: data.bookDescription2 || "",
    bookName3: data.bookName3 || "",
    bookPic3: data.bookPic3 || "",
    bookDescription3: data.bookDescription3 || "",
  };

  return {books, courseOutlineId: data.id};
};
